import { memo } from 'react';
import type { LinkFilterViewModel } from 'autogen/swagger/all';
import FilterMenuDrawer from '../../FilterMenu/FilterMenuDrawer';
import useFilterMenu from '../../FilterMenu/shared/hooks/useFilterMenu';
import LinkFilterOption from './LinkFilterOption';

const LinkFilterMenu = ({
    model: {
        displayName,
        options,
        queryStringName,
        attribute: { id }
    }
}: {
    model: LinkFilterViewModel;
}) => {
    const filterMenuId = id.toString();
    const { closeFilterMenu } = useFilterMenu(filterMenuId);
    return (
        <FilterMenuDrawer id={filterMenuId} headline={displayName} backButtonCallback={closeFilterMenu}>
            {options.map((option) => (
                <LinkFilterOption
                    key={option.displayName}
                    model={option}
                    queryStringName={queryStringName}
                    menuDisplayName={displayName}
                />
            ))}
        </FilterMenuDrawer>
    );
};

export default memo(LinkFilterMenu);
